import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-background-50 px-4 text-center">
      <span
        className="pointer-events-none absolute select-none font-heading text-[10rem] leading-none text-primary-100 md:text-[16rem]"
        aria-hidden="true"
      >
        404
      </span>
      <div className="relative z-10">
        <p className="flex items-center justify-center gap-2 text-sm text-primary-600">
          <i className="ri-emotion-sad-line text-xl" aria-hidden="true"></i>
          页面走丢了
        </p>
        <h1 className="mt-4 font-heading text-3xl text-foreground-950 md:text-4xl">
          这个页面还没被创造出来
        </h1>
        <p className="mt-3 text-base text-foreground-600">
          你访问的页面不存在或已被移动，试试回到首页继续找番吧
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition hover:bg-primary-600"
        >
          <i className="ri-home-4-line" aria-hidden="true"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}